@switch (mode) { @case ('radio') {

  <mat-radio-group [formControl]="formControl" (change)="ngOnChanges([])">
    <div class="flex flex-col justify-start">
      @for (option of options; track option) {
        <mat-radio-button [value]="option">
          <div class="mb-2 pl-2">
            <span class="font-bold">{{ option | role }}</span
              ><br /><span class="text-sm"
              >{{ "roles.inviteHints." + option | translate }}
            </span>
          </div>
        </mat-radio-button>
      }
    </div>
  </mat-radio-group>
  } @case('dropdown') {
  <mat-form-field appearance="outline">
    <mat-select
      class="full-width"
      matInput
      [placeholder]="placeholder || 'Select Role'"
      [formControl]="formControl"
      (selectionChange)="ngOnChanges([])"
      >
      @for (option of options; track option) {
        <mat-option [value]="option">{{
          option | role
        }}</mat-option>
      }
    </mat-select>
    @if (formControl.hasError('required')) {
      <mat-error>
        Role is <strong>required</strong>
      </mat-error>
    }
  </mat-form-field>

  } }
